import { render, staticRenderFns } from "./PerguntasPizza.vue?vue&type=template&id=7e740991&"
import script from "./PerguntasPizza.vue?vue&type=script&lang=js&"
export * from "./PerguntasPizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports